import { formatValue, NumeralType } from '@common/utils/formatNumberValue';

type NumeralValueFormatterProps = {
  type: NumeralType,
  customFormat?: string,
  fixedPrecision?: number,
  acceptRaw?: boolean,
}
export const numeralValueFormatter = ({
  type,
  customFormat = '',
  fixedPrecision,
  acceptRaw = false,
}: NumeralValueFormatterProps) => ({ value }: { value: string | number | null | undefined }) =>
  formatValue({
    value,
    type,
    customFormat,
    fixedPrecision,
    acceptRaw,
  });
